import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { ExternalPackageDetailsComponent } from '../../external-package/external-package-details/external-package-details.component';
import { ActivatedRoute } from '@angular/router';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { PathToLiveEnvironment } from 'src/app/models/blueprints/path-to-live-environment';
import { CreateSizingComponent } from '../../environment-details/environment-sizing-documents/create-sizing/create-sizing.component';
import { SizingService } from 'src/app/services/api/sizing.service';
import { isReleaseVersion } from '../../../services/util/utils';
import { SizingVideoTutorialDialogComponent } from '../../environment-details/environment-sizing-documents/sizing-video-tutorial-dialog/sizing-video-tutorial-dialog.component';
import { take } from 'rxjs';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { Attributes, Datazone, Permissions } from 'src/app/models/principal/permission';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';

const SIZING_PERMISSIONS = [
  { key: PermissionKeys.SIZING_CREATE_NONPII, action: Permissions.SIZING_CREATE, attribute: Attributes.DATAZONE, attributeValue: Datazone.NONPII },
  { key: PermissionKeys.SIZING_CREATE_PII, action: Permissions.SIZING_CREATE, attribute: Attributes.DATAZONE, attributeValue: Datazone.PII },
  { key: PermissionKeys.SIZING_CREATE_LIVE, action: Permissions.SIZING_CREATE, attribute: Attributes.DATAZONE, attributeValue: Datazone.LIVE },
];

@Component({
    selector: 'app-update-build-popup',
    templateUrl: './update-build-popup.component.html',
    styleUrls: ['./update-build-popup.component.scss'],
    standalone: false
})
export class UpdateBuildPopupComponent   implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() data;
  Constants = Constants;
  title: string;
  updateBuildForm: FormGroup;
  textbutton: string;
  index: any;
  versionData = [];
  dataselectedVersionId: any;
  dataselectedVersion: any;
  version: any;
  externalSelected: any;
  addExternalOption = false;
  tenantId: any;
  dropdownLoader: boolean;
  solutionVersionData: any;
  isVersionAvailable = true;
  hasCreatePermission: boolean = true;
  searchValue: any;
  filteredVersions: any;
  versionsList = [];
  selectedVersion: any;
  showSizingDropdown = false;
  showCreateSizingLink = false;
  showWatchTutorial = false;
  sizingDocumentsList: any;
  sizingDocuments: any;
  sizingDropdownSearchValue: string;
  isAWS: boolean;
  isSizingApplicable: boolean;
  solutionName = ['Tenant Shared Ingress' , 'Tenant Shared Services']
  environmentName =['TSS' ,'TSI']
  releaseMismatchText = '';


  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private blueprintsService: BlueprintsService,
     private configService: ConfigurationsService,
     public dialog: MatDialog, private solutionsService: SolutionsService, private toastrService: CustomToastrService,
     public solutionVersionsService: SolutionVersionsService, public route: ActivatedRoute, private sizingService: SizingService,
     private permissionsService: PermissionsService, private instancesService: InstancesService) {

     }

     ngOnInit(): void {
      this.isAWS = this.data.isAWS;
      this.dropdownLoader = false;
      this.tenantId = this.data?.tenantId;
      const isSolutionHidden = this.solutionName.some(sol => this.data.solution.name.includes(sol));
      const isEnvironmentHidden = this.environmentName.some(env => this.data.name.includes(env));
      this.isSizingApplicable = !(isEnvironmentHidden);
      this.blueprintsService.getBlueprintVersionById(this.data?.blueprintId, this.data?.blueprintVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        blueprintVersion => {
          this.selectedVersion = blueprintVersion;
          this.getSizingDocuments();
        });

      this.solutionsService.getSolutionVersions(this.data.solutionId).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.solutionVersionData = data;
          if (data) {
              data.forEach(element => {
                this.versionData.push(element);
              });
              if (this.data?.version) {
                let versions = [];
                let arr = [];
                data.forEach(element => {
                  arr.push(element.version);
                });
                arr = arr.map( a => a.split('.').map( n => +n+100000 ).join('.') ).sort()
                                .map( a => { const parts = a.split('.').map( n => +n-100000)
                                const major = parts[0];
                                const minor = parts[1] ? parts[1].toString().padStart(2, '0') : '00';
                                const patch = parts[2] ? parts[2].toString().padStart(2, '0') : '00';
                                return `${major}.${minor}.${patch}`;
               });
                let isGreater = false;
                arr?.forEach(item => {
                  if(isGreater) {
                    this.versionData.forEach(data => {
                      // Workaround: Skip preprodData check for PREPROD environment (URL-based detection)
                      if (this.data.environment === PathToLiveEnvironment.LIVE && !(window.location.href.split('.')[0].split('/')[2] === 'preprod') && this.dataVersion(data?.version) === item && this.dataVersion(this.data.preprodData?.version) ===  item){
                        versions = [...versions, data];
                      }
                      if (this.data.environment === PathToLiveEnvironment.LIVE && (window.location.href.split('.')[0].split('/')[2] === 'preprod') && this.dataVersion(data?.version) === item) {
                        versions = [...versions, data];
                      }
                      if (this.dataVersion(data?.version) === item && this.data.environment !== PathToLiveEnvironment.LIVE) {
                        versions = [...versions, data];
                      }
                  })
                  }
                  if (item === this.dataVersion(this.data?.version)) {
                    isGreater = true;
                  }
                })
                // this.versionData?.forEach(item => {
                //   if (Number(item?.version.split(".").join('')) > Number(this.data?.version.split(".").join(''))) {
                //     versions = [...versions, item];
                //   }
                // })
                this.versionData = this.versionData.map(item => item);

                if (this.data?.status === 'update_failed') {
                  versions.push(this.data);
                }
                if (versions?.length) {
                  this.versionGroup(versions);
                }
              }
              // this.versionData.sort((a, b) => {
              //   return b.version.localeCompare(a.version);
              // });
            this.dropdownLoader = true;
          }
        if(this.versionData.length === 0) {
          const noRelease = 'Release not Available';
          this.isVersionAvailable = false;
          this.versionData.push(noRelease);
        }
      },
      (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
    this.title = translate('INSTANCE_DETAILS.UPDATE_BUILD.SOLUTION_UPGRADE');
    this.createForm();
    this.checkCreateSizingPermission();
  }

  checkCreateSizingPermission(): void {
    this.instancesService.getInstanceById(this.data.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((instance: any) => {
        const dataZone = instance?.dataZone;
        const permissionsMap = this.permissionsService.resolveAPIPermissions(SIZING_PERMISSIONS);
        this.hasCreatePermission =
          (dataZone === Datazone.NONPII && permissionsMap[PermissionKeys.SIZING_CREATE_NONPII]) ||
          (dataZone === Datazone.PII && permissionsMap[PermissionKeys.SIZING_CREATE_PII]) ||
          (dataZone === Datazone.LIVE && permissionsMap[PermissionKeys.SIZING_CREATE_LIVE]);
      });
  }

  dataVersion(version): any {
    const offset = version.split('.').map(n => +n + 100000).join('.');
    const parts = offset.split('.').map(n => +n - 100000);
    const major = parts[0];
    const minor = parts[1]?.toString().padStart(2, '0') || '00';
    const patch = parts[2]?.toString().padStart(2, '0') || '00';
    return `${major}.${minor}.${patch}`;
  }

  onOptionsSelected(data){
   this.versionData = this.versionsList.filter(item => item?.version.includes(data.value));
  }
  // Selected sizing dcument
  onSizingDocOptionsSelected(data){
   this.sizingDocuments = this.sizingDocumentsList?.filter(item => item?.name?.includes(data.value));
  }

  getBuildForm(): any {
    if (!FormUtilService.validateForm(this.updateBuildForm)) {
      return;
    }
    const releaseVersion = this.updateBuildForm.getRawValue();
      if(releaseVersion.buildVersion === 'Release not Available'){
        return;
      }
    const dataSelected = this.updateBuildForm.getRawValue();
    this.solutionVersionData?.forEach(data => {
      if(data.version === dataSelected.buildVersion) {
        this.dataselectedVersion = data.version;
        this.dataselectedVersionId = data.id;
      }
    });
    if (!this.dataselectedVersionId) {
          if (this.data?.taskSolutionVersion?.releaseVersion === dataSelected.buildVersion) {
            this.dataselectedVersionId = this.data?.taskSolutionVersion?.id;
          }
      }
    const finalData = {
      dataselectedVersionId : this.dataselectedVersionId,
      externalSelected : this.externalSelected,
      sizingDocumentId: dataSelected.sizingDocument
    }
    return finalData;
  }

  selectExternalTypes(): void {
    if(this.externalSelected) {
      this.externalSelected = false;
    } else {
      this.externalSelected = true;
    }
  }

  updateBuild(): void {
    if (!this.getBuildForm()) {
      return;
    }
    // displaying warning popup for failed environment.Upon user confirmation, proceed with submission.
    if (this.data.showWarningPopup) {
      this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '650px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_BUILD.WARNING_TITLE', {
          action: translate('INSTANCE_DETAILS.UPDATE_BUILD.SOLUTION_UPGRADE')}),
        message: translate('INSTANCE_DETAILS.UPDATE_BUILD.WARNING_NOTE', {
          action: translate('INSTANCE_DETAILS.UPDATE_BUILD.SOLUTION_UPGRADE')}),
        confirmButtonText: translate('INSTANCE_DETAILS.UPDATE_BUILD.PROCEED'),
        warning: true
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
         this.updateSolutionVersion();
      }
      });
    } else {
      this.updateSolutionVersion();
    }
  }
  // displaying confimation popup and updating solution version
  updateSolutionVersion() {
    const isEnvironmentHidden = this.environmentName.some(env => this.data.name.includes(env));
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('INSTANCE_DETAILS.UPDATE_BUILD.TITLE'),
        message: translate('INSTANCE_DETAILS.UPDATE_BUILD.MESSAGE') + this.dataselectedVersion,
        note: isEnvironmentHidden ? '' : translate('INSTANCE_DETAILS.UPDATE_BUILD.NOTE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.sidenavService.closeRightSidenav(this.getBuildForm());
        }
      });
  }

  externalPackageInfo(): void {
    if (this.data.packageReferenceId) {
      this.dialog.open(ExternalPackageDetailsComponent, {
        height: '85vh',
        width: '50vw',
        panelClass: 'custom-pack-dialog',
        data: this.data
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
        }
      });
    }
  }

  createForm(): void {
    const formConfig: any = {
      buildVersion: [undefined, [Validators.required]],
      searchValue: [''],
      sizingDocument: [undefined],
      sizingDropdownSearchValue: ['']
    };
    this.updateBuildForm = this.formBuilder.group(formConfig);
    if (this.data?.configurationId) {
      this.configService.getConfigurations(this.data?.blueprintId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(version => {
        if (version?.length) {
          const filteredVersion = version.filter(
            v => v.id === this.data.configurationId
          );
          this.version = filteredVersion[0];
        }
      });
    }
  }

  searchChanged(value): void {
    this.versionData = this.versionsList;
  }

  resetFilter(): void {
    this.updateBuildForm.get('searchValue').reset();
    this.versionData = this.versionsList;
  }

  // Update sizing document when search changed
  sizingSearchChanged(value): void {
    this.sizingDocuments = this.sizingDocumentsList;
  }
 //Reset sizing document filter
  resetSizingDocFilter(): void {
    this.updateBuildForm.get('sizingDropdownSearchValue').reset();
    this.sizingDocuments = this.sizingDocumentsList;
  }
 //Reset if the selected item is empty
  sizingDropdownClose(): void {
    if (this.sizingDocuments?.length === 0) {
      this.sizingDocuments = this.sizingDocumentsList;
    }
  }

  /**
   * Handles target version selection.
   * Enables external option if major versions match.
   * Controls sizing dropdown and create sizing link based on version format.
  */
  private readonly UPGRADE_VIDEO_DISMISSED_KEY = 'upgrade-video-dismissed';

  openUpgradeTutorial(): void {
    this.dialog.open(SizingVideoTutorialDialogComponent, {
      width: '720px',
      disableClose: false,
      panelClass: 'default-dialog-wrapper',
      data: {
        videoUrl: '/assets/media/Upgrade-Environment.mp4',
        title: translate('UPGRADE_VIDEO_TUTORIAL.TITLE'),
        description: translate('UPGRADE_VIDEO_TUTORIAL.DESCRIPTION')
      }
    }).afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        localStorage.setItem(this.UPGRADE_VIDEO_DISMISSED_KEY, 'true');
        this.showWatchTutorial = true;
      });
  }

  getSelectedVersion(event): void {
    const isEnvironmentHidden = this.environmentName.some(env => this.data.name.includes(env));
    this.showWatchTutorial = isReleaseVersion(event) && !isEnvironmentHidden;
    if (isReleaseVersion(event) && !isEnvironmentHidden && !localStorage.getItem(this.UPGRADE_VIDEO_DISMISSED_KEY)) {
      this.openUpgradeTutorial();
    }

    this.releaseMismatchText = '';
    if (this.data?.configurationId && this.version && this.version?.manifest?.references) {
      let instanceReferenceVersion = this.version?.manifest?.references?.packages.find(item => item.name?.includes('tap'))?.name?.split('-')[3];
      let solutionVersion = event;
      if (instanceReferenceVersion && solutionVersion && instanceReferenceVersion !== solutionVersion) {
        this.releaseMismatchText = translate('INSTANCE_DETAILS.VERSION_MISMATCH_DESCRIPTION_DEPLOYED').replace(/solutionVersion/g, solutionVersion).replace(/referenceVersion/g, instanceReferenceVersion);
      }
    }

    if(this.data?.version?.split('.',1).toString() === event.split('.',1).toString())  {
      this.addExternalOption = true;
    } else {
      this.addExternalOption = false;
    }

    const sizingDoc = this.updateBuildForm.get('sizingDocument');
    this.showSizingDropdown = false;
    if(isReleaseVersion(event) && !this.isAWS) {
      sizingDoc?.setValidators([Validators.required]);
      this.showSizingDropdown = true;
      if (this.sizingDocuments?.length === 0) {
        this.showCreateSizingLink = true;
      }
    } else {
      sizingDoc?.clearValidators();
      sizingDoc?.setValue(null);
    }

  }

  openCreateSizingDialog(): void {
    if (!this.hasCreatePermission) {
      this.dialog.open(ErrorDialogComponent, {
        width: '560px',
        minHeight: '260px',
        panelClass: 'flex-dialog',
        data: {
          noPermission: true,
          title: translate('SIZING.NO_PERMISSION_TITLE')
        }
      });
    } else {
    this.dialog.open(CreateSizingComponent, {
      width: '90vw',
      maxWidth: '90vw',
      height: '90vh',
      panelClass: 'create-sizing-dialog',
      disableClose: true,
      data: {
        instanceId: this.data?.id,
        blueprintId: this.data?.blueprintId
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(confirm => {
      if (confirm) {
        this.getSizingDocuments();
      }
    })
  }
  }

  /**
 * Fetches sizing documents for the given instanceID
 */
  getSizingDocuments(): void {
    this.sizingService.getSizingDocs(this.data.id)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(response => {
      this.sizingDocumentsList = response;
      if(response?.length > 0 && this.data?.sizingDocumentId) {
        const result = response.find(item => item.id === this.data?.sizingDocumentId);
        const name = result ? result.name : null;
        this.sizingDocumentsList = this.getNextVersionName(response, name);
      } else {
        this.sizingDocumentsList = response;
      }

      this.sizingDocuments = this.sizingDocumentsList;
      if (this.sizingDocuments?.length > 0) {
        this.showCreateSizingLink = false;
      } else {
        this.showCreateSizingLink = true;
      }
    },
    (error) => {
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  getNextVersionName(data: any[], currentName: string): any[] {
    if (currentName) {
      const [baseVersion, currentVersion] = currentName.split('_v');
      const [base, current] = (currentVersion).split('.').map(Number);;
      const latestMap = new Map<string, any>();

      data.forEach(item => {
        const existing = latestMap.get(item.id);

        if (!existing) {
          latestMap.set(item.id, item);
        } else {
          const existingDate = new Date(existing.updatedAt).getTime();
          const currentDate = new Date(item.updatedAt).getTime();

          if (currentDate > existingDate) {
            latestMap.set(item.id, item);
          }
        }
      });

      const latestData = Array.from(latestMap.values());
      return latestData
        .filter(item => {
          const [b1, v1] = item.name.split('_v');
          const [b, v] = (v1).split('.').map(Number);;

          return b === base && v >= current;
        })
        .sort((a, b) => {
          const va = parseFloat(a.name.split('_v')[1]);
          const vb = parseFloat(b.name.split('_v')[1]);
          return va - vb;
        });
    }
  }

  dropdownClose(): void {
    if (this.versionData?.length === 0) {
      this.versionData = this.versionsList;
    }
  }

  versionGroup(versions) {
    let group = [];
    this.versionsList = versions;
    this.versionsList.forEach(item => {
      group.push(item?.version?.split('.')[0]);
    });
    group = [...new Set(group)];

    let makeGrouping = [];
    group.forEach(groupItem => {
      const versions: any = this.versionsList.filter(item => item?.version?.split('.')[0] === groupItem);
      const releaseVersion = versions[0]?.releaseVersion || versions[0]?.version || '';
      const releasePrefix = releaseVersion?.split('.')?.[0] || '';
      const groupName = {version: groupItem, group: true, releaseVersion: releasePrefix.length > 2 ? releasePrefix : 'R' + releasePrefix };
      versions.push(groupName);
      makeGrouping.push(versions);
    });

    const combineData = makeGrouping.flat();
    const finalData = combineData.sort((a, b) => {
      if (a.version < b.version) return -1;
      if (a.version > b.version) return 1;
    })

    this.versionsList = finalData;
    this.versionData = finalData;
  }

}
